import validationConfig from "@/global/apivalidationconfig.js";

let value, config, key, type, apiValues, callName;
let guidRegex = new RegExp(/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/);

export default {
    // A special function to properly validate the question objects, because there can be a varying amount of questions, subquestions and answers
    validateQuestionObj: function(obj){
        this.validate(obj, `questionActionObject`);

        obj?.questions?.forEach(question => {
            this.validate(question, `question`);
            this.validate(question.validation, `validation`);
            question.media.forEach(media => this.validate(media, `media`));

            if(question.answers) this.validateAnswerObj(question.answers);
            if(question.settings) this.validate(question.settings, `questionSettings`)

            if(question.subQuestions) {
                question.subQuestions.forEach(sq => {
                    this.validate(sq, `question`); //questions and subquestions tend to have the same properties
                    if(question.answers) this.validateAnswerObj(question.answers);
                });
            }
        });
    },
    // Helper function for the validateQuestionObj function
    validateAnswerObj: function(answers){
        answers.forEach(answer => {
            this.validate(answer, `answer`);

            answer.media.forEach(media => this.validate(media, `media`));
            this.validate(answer.validation, `validation`);
        });
    },
    // Validate a property
    validate: function (_apiValues, _callName, _allPropsShouldBePresent = false) {
        let config = validationConfig[_callName];
        apiValues = _apiValues;
        callName = _callName;
        
        // If all properties in the config should be present, make sure that they are
        if(_allPropsShouldBePresent) this.fillInBlanks(apiValues, config);
        
        return this.validateKeys(apiValues, config);
    },
    // Add missing properties that are supposed to be there but weren't received from the server
    fillInBlanks: function(props, config){
        for(let propName in config) {
            if(props[propName] === undefined) {
                props[propName] = undefined;
            }

            if(config[propName].children) {
                this.fillInBlanks(props[propName], config[propName].children);
            }
        }
    },
    // Validate whether all the received properties are correct
    validateKeys: function (apiValues, validationConfig) {
        for (key in apiValues) {
            value = apiValues[key];
            config = validationConfig[key];

            // If they key does not exist in the config, there is nothing to validate
            if (config === undefined) continue;

            let min = config.min;
            let max = config.max;
            type = config.type;
    
            if (type === `color`) {
                if (value === null || value === undefined || value.charAt(0) !== `#`) {
                    this.updatePropertyToDefault(apiValues);
                }
            }
            else if (type === `guid`) {
                if (value === null || value === undefined || guidRegex.test(value) === false) {
                    this.updatePropertyToDefault(apiValues);
                }
            } else if (type === `object`) {
                if (value === null || value === undefined || value.constructor !== Object) {
                    this.updatePropertyToDefault(apiValues);
                }
            } else if(type === `array`){
                if (value === null || value === undefined || !Array.isArray(value)) {
                    this.updatePropertyToDefault(apiValues);
                }
            } else if (typeof value !== type) {
                this.updatePropertyToDefault(apiValues);
            }

            if (min && value < min) {
                apiValues[key] = min;
            } else if (max && value > max) {
                apiValues[key] = max;
            } else if (config.children) {
                apiValues[key] = this.validateKeys(apiValues[key], config.children); // If there are children, validate these keys as well
            }
        }

        return apiValues;
    },
    //If a value was validated as wrong, change the value to the configured default value
    updatePropertyToDefault: function (objToChange) {
        if (config.dontShowError !== true) {
            console.error(`Value of ${key} in ${callName} is not in the right format, it should be a ${type}. Current value: ${value}. This is an api-validation error.`);
        }
        
        if (config.default !== undefined) objToChange[key] = config.default;
    }
}